import AnimateOnEnter from "@/ui/animations/AnimateOnEnter"
import Typography from "@/ui/atoms/Typography"
import Container from "@/ui/structure/Container"
import { classNames } from "@punks/ui-core"
import { ReactNode } from "react"

export interface FormContainerProps {
  color?: "light" | "dark" | "primary"
  message?: ReactNode
  title?: ReactNode
  subtitle?: ReactNode
  cover?: ReactNode
  children?: any
}

const FormContainer = ({
  color,
  children,
  message,
  subtitle,
  cover,
  title,
}: FormContainerProps) => {
  return (
    <div>
      {cover && <div className="w-full px-16 pt-16">{cover}</div>}
      <div
        className={classNames({
          "bg-negative-contrast text-negative": color === "dark",
          "bg-primary text-primary-contrast": color === "primary",
        })}
      >
        <Container className="py-16">
          <AnimateOnEnter>
            {title && (
              <Typography
                variant={["h4", "h2"]}
                textTransform={"uppercase"}
                weight={"semiBold"}
                textAlign={"center"}
                inheritColor
                className="mb-4"
              >
                {title}
              </Typography>
            )}

            {subtitle && (
              <Typography
                variant={"h2"}
                textAlign={"center"}
                inheritColor
                className="mb-6"
              >
                {subtitle}
              </Typography>
            )}
            {message && (
              <Typography
                variant={"body2"}
                textAlign={"center"}
                inheritColor
                className="xl:max-w-[740px] mx-auto"
              >
                {message}
              </Typography>
            )}
          </AnimateOnEnter>
          <div className="mt-24 lg:px-[160px]">{children}</div>
        </Container>
      </div>
    </div>
  )
}

export default FormContainer
